// @flow
import type { Store } from 'redux';
import { addForm } from 'esm-web-pro/redux/workflow/form';


const requestFormInputCallback = (data: {
    workflow_code: string,
    execution_id: string,
    root_workflow_code: ?string,
    root_execution_nid: ?string,
    schema: string,
    key: string,
    initial_data: ?Object,
    button_label: ?string,
    title: ?string,
    modal: ?boolean,
}, context: { store: Store }) => {
    context.store.dispatch(addForm(
        data.workflow_code,
        data.execution_id,
        data.root_workflow_code,
        data.root_execution_id,
        data.schema,
        data.key,
        data.initial_data,
        data.button_label,
        data.title,
        data.modal,
    ));
};


// eslint-disable-next-line
export const request_form_input = {
    async: false,
    func: requestFormInputCallback,
};
